import { atom, useSetAtom } from 'jotai';
import { atomWithDefault, RESET } from 'jotai/utils';
import { cloneDeep } from 'lodash-es';
import { useCallback } from 'react';
import { IField } from '../../../data-models/field2.data-model';
import { CustomFieldFormType } from './CustomField.schema';
import { toFieldViewModel } from './custom-field-form.view-model';

export const CustomFieldFormInitialValuesState = atom<IField<unknown> | null>(null);

export const CustomFieldFormDataState = atomWithDefault<Partial<CustomFieldFormType> | null>((get) => {
  const initialValues = get(CustomFieldFormInitialValuesState);
  if (!initialValues) {
    return null;
  }
  return cloneDeep(toFieldViewModel(initialValues));
});

/**
 * Current step (zero-indexed) for the multi-step custom-field form.
 */
export const customFieldFormCurrentStepStateJ = atom<number>(0);

export function useResetCustomFieldFormState() {
  const resetFormData = useSetAtom(CustomFieldFormDataState);
  const resetInitialState = useSetAtom(CustomFieldFormInitialValuesState);
  const setCurrentStep = useSetAtom(customFieldFormCurrentStepStateJ);

  return useCallback(() => {
    resetInitialState(null);
    resetFormData(RESET);
    setCurrentStep(0);
  }, [resetFormData, resetInitialState, setCurrentStep]);
}
